import { Component } from '@angular/core';
import { ApplicationHostTypeService, ReferenceDataLabels } from 'rome-library';
import { States } from '../../../shared';
import { DirectFooterConfigurationService } from '../../services/direct-footer-configuration.service';

@Component({
  selector: 'boi-vo-application-footer',
  templateUrl: './application-footer.component.html'
})
export class ApplicationFooterComponent {
  public referenceDataLabels = ReferenceDataLabels;
  public readonly states = States;
  public currentYear: number;

  constructor(
    public readonly applicationHostTypeService: ApplicationHostTypeService,
    public readonly footerConfigurationService: DirectFooterConfigurationService
  ) {
    this.currentYear = new Date().getFullYear();
  }
}
